import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import validator from 'validator';
import withInit from 'WithInit';
import { FormSwiftModal } from 'DesignSystem';
import ModalActions from 'DesignSystem/FormSwiftModal/ModalActions';
import ModalBody from 'DesignSystem/FormSwiftModal/ModalBody';
import ModalError from 'DesignSystem/FormSwiftModal/ModalError';
import ModalHeader from 'DesignSystem/FormSwiftModal/ModalHeader';
import EmailInput from 'DesignSystem/TextInputs/EmailInput';
import { closeEmailModal, sendSessionLinkEmail } from 'StaticBuilder/SessionEmail/SessionEmailActions';

const StaticEmailModal = ({
  closeEmailModal: closeModal,
  documentType,
  emailSendError,
  isEmailModalOpen,
  sendSessionLinkEmail: sendEmail,
  sessionHash,
  sessionId,
}) => {
  const [email, setEmail] = useState('');

  const sendEmailOnClick = useCallback(async () => {
    if (validator.isEmail(email.trim())) {
      await sendEmail(
        sessionId,
        sessionHash,
        documentType,
        email,
        closeModal,
      );
    }
  });

  const emailOnChange = useCallback((e) => {
    setEmail(e.target.value);
  });

  return (
    <FormSwiftModal
      className="send-session-link-email-modal"
      handleCloseModal={closeModal}
      isCloseButtonVisible
      isOpen={isEmailModalOpen}
    >
      <ModalError errorCopy={emailSendError} />
      <ModalHeader headerCopy="Access This Document Later" />
      <ModalBody>
        <p className="send-session-link-email-subheader">
          Send yourself a link to this document to complete and export at another time.
        </p>
        <EmailInput
          id="sessionLinkEmailInput"
          label="Your Email Address:"
          onChange={emailOnChange}
          placeholder="Email"
          value={email}
        />
      </ModalBody>
      <ModalActions
        primaryCta={{
          btnCopy: 'Send Link',
          className: 'send-session-link-email-button',
          onClick: sendEmailOnClick,
        }}
      />
    </FormSwiftModal>
  );
};

StaticEmailModal.defaultProps = {
  documentType: '',
  emailSendError: '',
  isEmailModalOpen: false,
  sessionHash: '',
  sessionId: '',
};

StaticEmailModal.propTypes = {
  closeEmailModal: PropTypes.func.isRequired,
  documentType: PropTypes.string,
  emailSendError: PropTypes.string,
  isEmailModalOpen: PropTypes.bool,
  sendSessionLinkEmail: PropTypes.func.isRequired,
  sessionHash: PropTypes.string,
  sessionId: PropTypes.string,
};

const mapStateToProps = ({ SessionEmailReducer }) => ({
  emailSendError: SessionEmailReducer.emailSendError,
  isEmailModalOpen: SessionEmailReducer.isEmailModalOpen,
});

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    closeEmailModal,
    sendSessionLinkEmail,
  }, dispatch)
);

export const StaticEmailModalWithRedux = ReactRedux.connect(
  mapStateToProps,
  mapDispatchToProps,
)(StaticEmailModal);

export default withInit(StaticEmailModalWithRedux, true);



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/SessionEmail/StaticEmailModal.jsx